
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/wisdom/quotes/date/[date]",
      function () {
        return require("private-next-pages/[region]/wisdom/quotes/date/[date]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/wisdom/quotes/date/[date]"])
      });
    }
  